import { Directive, ElementRef, Inject, OnInit } from '@angular/core';
import { componentStylesByTheme } from '../../utils/theme.utils';
import { THEME_TOKEN, Theme } from '../../types/theme.types';
import { tableHeadStylesSAG, tableHeadStylesSHS } from './table-head.styles';
import { style } from '../../utils/style.utils';

@Directive({
  selector: 'thead[sag-ui-thead]',
})
export class TableHeadDirective implements OnInit {
  constructor(
    @Inject(THEME_TOKEN) private readonly theme: Theme,
    private readonly elementRef: ElementRef<HTMLInputElement>
  ) {}

  ngOnInit(): void {
    const inputStyles = componentStylesByTheme(
      this.theme,
      tableHeadStylesSAG,
      tableHeadStylesSHS
    );
    style(this.elementRef, inputStyles());
  }
}
